const pla = {
	path: '/pla',
	component: ()=>import("@/views/main.vue"),
	children:[
		{
			path: 'Menu',
			component: ()=>import("@/views/pla/Menu.vue"),
			meta:{
				title:"菜单管理",
				requiresAuth:false
			},
		},
		{
			path: 'Fat',
			component: ()=>import("@/views/pla/Fat.vue"),
			meta:{
				title:"供应商信息",
				requiresAuth:false
			},
		},
		{
			path: 'Home',
			component: ()=>import("@/views/pla/Home.vue"),
			meta:{
				title:"首页",
				requiresAuth:false
			},
		},
		{
			path: 'Pro',
			component: ()=>import("@/views/pla/Pro.vue"),
			meta:{
				title:"服务商信息",
				requiresAuth:false
			},
		},
		{
			path: 'Promoter',
			component: ()=>import("@/views/pla/Promoter.vue"),
			meta:{
				title:"推广员",
				requiresAuth:false
			},
		},
		{
			path: 'Merchant',
			component: ()=>import("@/views/pla/Merchant.vue"),
			meta:{
				title:"商户信息",
				requiresAuth:false
			},
		},
		{
			path: 'Fatlog',
			component: ()=>import("@/views/pla/Fatlog.vue"),
			
		},
		{
			path: 'ShopCateg',
			component: ()=>import("@/views/pla/ShopCateg.vue"),
			meta:{
				title:"商品类别",
				requiresAuth:false
			},
		},
		{
			path: 'Brand',
			component: ()=>import("@/views/pla/Brand.vue"),
			meta:{
				title:"品牌审核",
				requiresAuth:false
			},
		},
		{
			path: 'Shop',
			component: ()=>import("@/views/pla/Shop.vue"),
			meta:{
				title:"商品信息",
				requiresAuth:false
			},
		},
		{
			path: 'Content',
			component: ()=>import("@/views/pla/Content.vue"),
			meta:{
				title:"内容管理",
				requiresAuth:false
			},
		},
		{
			path: 'ContentEdit/:c_id/:type',
			component: ()=>import("@/views/pla/ContentEdit.vue"),
		},
		{
			path: 'shopCheck',
			component: ()=>import("@/views/pla/shopCheck.vue"),
			meta:{
				title:"供应商商品审核",
				requiresAuth:false
			},
		},
		{
			path: 'FatCheck',
			component: ()=>import("@/views/pla/FatCheck.vue"),
			meta:{
				title:"供应商审核",
				requiresAuth:false
			},
		},
		{
			path: 'PaymentCheck',
			component: ()=>import("@/views/pla/PaymentCheck.vue"),
			meta:{
				title:"供应商收款审核",
				requiresAuth:false
			},
		},
		{
			path: 'ShopAdd/:good_id/:fat_id/:id/:type',
			component: ()=>import("@/views/pla/ShopAdd.vue"),
			meta:{
				title:"商品审核",
				requiresAuth:false
			},
		},
		{
			path: 'User',
			component: ()=>import("@/views/pla/User.vue"),
			meta:{
				title:"员工管理",
				requiresAuth:false
			},
		},
		{
			path: 'ServiceProviderExamine',
			component: ()=>import("@/views/pla/ServiceProviderExamine.vue"),
			meta:{
				title:"服务商审核",
				requiresAuth:false
			},
		},
		{
			path: 'ServiceProvider',
			component: ()=>import("@/views/pla/ServiceProvider.vue"),
			meta:{
				title:"服务商",
				requiresAuth:false
			},
		},
		{
			path: 'Role',
			component: ()=>import("@/views/pla/Role.vue"),
			meta:{
				title:"角色管理",
				requiresAuth:false
			},
		},
		{
			path: 'Vehicle',
			component: ()=>import("@/views/pla/Vehicle.vue"),
			meta:{
				title:"车辆管理",
				requiresAuth:false
			},
		},
		{
			path: 'Level',
			component: ()=>import("@/views/pla/Level.vue"),
			meta:{
				title:"等级管理",
				requiresAuth:false
			},
		},
		{
			path: 'Marketing',
			component: ()=>import("@/views/pla/Marketing.vue"),
			meta:{
				title:"营销活动",
				requiresAuth:false
			},
		},
		{
			path: 'OrderDkzx',
			component: ()=>import("@/views/pla/OrderDkzx.vue"),
			meta:{
				title:"甄选订单",
				requiresAuth:false
			},
		},
		{
			path: 'Supplier',
			component: ()=>import("@/views/pla/Supplier.vue"),
			meta:{
				title:"甄选订单",
				requiresAuth:false
			},
		},
		{
			path: 'Merber',
			component: ()=>import("@/views/pla/Merber.vue"),
			meta:{
				title:"会员信息",
				requiresAuth:false
			},
		},
		{
			path: 'dayReport',
			component: ()=>import("@/views/pla/dayReport.vue"),
			meta:{
				title:"订单日报表",
				requiresAuth:false
			},
		},
		{
			path: 'ShopReport',
			component: ()=>import("@/views/pla/ShopReport.vue"),
			meta:{
				title:"商品日报表",
				requiresAuth:false
			},
		},
		{
			path: 'dkzxLunShop',
			component: ()=>import("@/views/pla/dkzxLunShop.vue"),
			meta:{
				title:"商品日报表",
				requiresAuth:false
			},
		},
		{
			path: 'wholeSale',
			component: ()=>import("@/views/pla/wholeSale.vue"),
			meta:{
				title:"整卖",
				requiresAuth:false
			},
		},
		{
			path: 'wholeSaleAdd/:good_id/:fat_id/:id/:type',
			component: ()=>import("@/views/pla/wholeSaleAdd.vue"),
			meta:{
				title:"整卖添加",
				requiresAuth:false
			},
		},
		{
			path: 'StoreCheck',
			component: ()=>import("@/views/pla/StoreCheck.vue"),
			meta:{
				title:"门店主体审核",
				requiresAuth:false
			},
		},
		{
			path: 'MerchantStore',
			component: ()=>import("@/views/pla/MerchantStore.vue"),
			meta:{
				title:"门店列表",
				requiresAuth:false
			},
		},
		{
			path: 'PriceAju',
			component: ()=>import("@/views/pla/PriceAju.vue"),
			meta:{
				title:"调价单审核",
				requiresAuth:false
			},
		},
		{
			path: 'PriceAjuAdd/:price_no/:flow_no',
			component: ()=>import("@/views/pla/PriceAjuAdd.vue"),
			meta:{
				title:"调价单信息",
				requiresAuth:false
			},
		},
		{
			path: 'Attribute',
			component: ()=>import("@/views/pla/Attribute.vue"),
			meta:{
				title:"商品属性",
				requiresAuth:false
			},
		},
	]
}
export default pla